import { useState } from "react";
import Typography from "@mui/material/Typography";
import { ContentStyle } from "../../Theme";
import ProfileTabsNav from "../../components/ProfileTabsNav";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import AllergiesList from "../Allergies/AllergiesList";

export default function AllergyInformation(props: any) {
  const [showStatus] = useState(false);

  return (
    <>
      <ProfileTabsNav />{" "}
      <ContentStyle>
        <Typography
          className="help"
          component="h6"
          color="primary"
          variant="h6"
        >
          Allergy History
          <HelpGuideTooltip
            content={
              <Typography component="div" variant="body1">
                This section shows the allergies that were added by prescriber
                on a patient record
              </Typography>
            }
          />
        </Typography>
        <AllergiesList showStatus={showStatus} />
      </ContentStyle>
    </>
  );
}
